import React from 'react';
import { Callout, CalloutProps } from './Callout';

export const Check: React.FC<Omit<CalloutProps, 'type'>> = (props) => (
  <Callout type="check" {...props} />
);

export default Check;
